import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import FsPayWarehouse from './FsPayWarehouse';


const FsPayWarehouseNav = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <FsPayWarehouse className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default FsPayWarehouseNav;